import React, { useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { Storage, useStore } from '../lib'

export const Login = () => {
  const [username, setUsername] = useState<string>('')
  const history = useHistory()
  const { state, setState } = useStore()
  const login = () => {
    if (state.username !== username) {
      Storage.setBackup(state.username, state)
      Storage.remove()
      const lastProfile = Storage.getBackup(username)
      if (lastProfile?.username === username && !!lastProfile.games) {
        if (isNaN(lastProfile.timeMs)) {
          lastProfile.timeMs = 0
        }
        setState(lastProfile)
      } else {
        setState({
          username,
          score: 0,
          errors: 0,
          timeMs: 0,
          isWinter: false,
          isFirstRun: true,
          games: {},
        })
      }
    }
    history.push('/dashboard')
  }
  return (
    <div className="view background-summer">
      <div
        className="p-10 text-black"
        style={{
          maxWidth: window.innerWidth > 768 ? '35vw' : '96vw',
          width: window.innerWidth > 768 ? '35vw' : '96vw',
        }}
      >
        <div className="card glass p-5">
          <h1 className="text-left text-2xl font-bold mb-5">Vyplň svoje jméno:</h1>
          <div className="form-control mb-5">
            <input
              type="text"
              className="input input-primary input-lg"
              value={username}
              onChange={e => setUsername(e.target.value)}
              onSubmit={login}
            />
          </div>
          <button className="btn btn-primary btn-block mt-5 text-2xl" onClick={login} disabled={username?.length < 3}>
            {username?.length < 3 ? 'Zadej jméno' : `Vstoupit`}
          </button>
        </div>
        {/*<div>*/}
        {/*  <NavLink to={'/'} className="text-black btn btn-block btn-link">zpět</NavLink>*/}
        {/*</div>*/}
        <div className="fixed z-10 bottom-0 left-5">
          <button className="text-xl text-black btn btn-block mb-5 glass" onClick={() => history.goBack()}>
            zpět
          </button>
        </div>
      </div>
    </div>
  )
}
